import React from "react";
import { Dialog, DialogContent, DialogTitle, Button, Typography } from "@mui/material";

interface MessageDialogProps {
    open: boolean;
    message: string;
    severity?: "success" | "error";
    onClose: () => void;
}

export default function MessageDialog({
    open,
    message,
    severity = "success",
    onClose,
}: MessageDialogProps) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            hideBackdrop
            disableEnforceFocus
            PaperProps={{
                sx: {
                    borderTop: `6px solid ${
                        severity === "success" ? "#2e7d32" : "#d32f2f"
                    }`,
                    minWidth: { xs: "auto", sm: 300 },
                    zIndex: (theme) => theme.zIndex.modal + 5000, // 🔥 sopra tutto
                },
            }}
            sx={{
                zIndex: (theme) => theme.zIndex.modal + 5000, // 🔥 sopra tutto
            }}
        >
            <DialogTitle>
                {severity === "success" ? "Success" : "Error"}
            </DialogTitle>

            <DialogContent>
                <Typography sx={{ mb: 2 }}>{message}</Typography>

                <Button
                    variant="contained"
                    color={severity === "success" ? "success" : "error"}
                    onClick={onClose}
                    fullWidth
                >
                    OK
                </Button>
            </DialogContent>
        </Dialog>
    );
}
